import { styled } from '@mui/material/styles';
import Constancia from './layout/LayoutConstancia';

const Root = styled('div')(({ theme }) => ({
    background: "#ffffff",
    width: '200%',
    marginTop: '-1.5%',
    [theme.breakpoints.down('lg')]: {
        width: '100%',
        height: '100%',
    },
    [theme.breakpoints.down('md')]: {
        width: '100%',
        height: '100%',
    },
    [theme.breakpoints.up('md')]: {
        width: '100%',
        height: '100%',
    },
    [theme.breakpoints.up('lg')]: {
        width: '100%',
        height: '100%',
    },
}));

export default function VistaConstancia(){
    return (
        <Root>
            <Constancia />
        </Root>
    )
}